import { FunctionalComponent, h } from '@stencil/core'
import { JSXBase } from '@stencil/core/internal'
import { css, keyframes } from 'src/lib/emotion'

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`
const animation = css`
  animation: ${spin} 2s linear infinite;
`
export const SyncIndicator: FunctionalComponent<JSXBase.IntrinsicElements['span']> = (_, children) => (
  <span
    style={{ width: '20px', height: '20px' }}
    class={`text-2xs uppercase font-bold flex items-center text-info-warn animate duration-200`}
  >
    <ui-icon class={animation} style={{ fontSize: '1.5em' }} icon='arrow-repeat'></ui-icon>
    <span class='tracking-wide'>{children}</span>
  </span>
)
